/**
 * All user-visible static text for DomainActionModal and its sub-components.
 */

// ── Add Domain ─────────────────────────────────────────────────────────────
export const ADD_DOMAIN_TITLE       = "Add Domain";
export const ADD_DOMAIN_FIELD_LABEL = "Domain Name";
export const ADD_DOMAIN_PLACEHOLDER = "Enter Domain Name";
export const BTN_BACK               = "Back";
export const BTN_CLEAR_ALL          = "Clear All";
export const BTN_SAVE               = "Save";
export const HELPER_TEXT            = "Example: coke.com";

// ── Upload Domain ──────────────────────────────────────────────────────────
export const UPLOAD_TITLE           = "Upload Domains via Excel";
export const UPLOAD_DESCRIPTION     = "Upload a CSV or Excel file containing Domain names. The first column must contain the domain.";
export const UPLOAD_BROWSE_LABEL    = "Click to browse";
export const UPLOAD_DRAG_DROP       = "or drag & drop";
export const UPLOAD_SUPPORTS        = "Supports .csv, .xls, .xlsx";
export const UPLOAD_TEMPLATE_FILE   = "Domain_Template.xlsx";
export const UPLOAD_TEMPLATE_SHEET  = "Template";
export const UPLOAD_FORMAT_LABEL    = "Expected format:";
export const UPLOAD_COLUMN_NAME     = "Domain Name";
export const UPLOAD_EXAMPLE_DOMAIN  = "supplier.com";
export const BTN_DOWNLOAD_TEMPLATE  = "Download Template";
export const BTN_CANCEL             = "Cancel";
export const BTN_UPLOAD_DOMAINS     = "Upload Domains";

// ── Whitelist Domain ───────────────────────────────────────────────────────
export const WHITELIST_TITLE        = "Whitelist Domains";
export const WHITELIST_DESCRIPTION  = "The following domains have been selected for whitelisting. Provide a business justification and submit";
export const WHITELIST_DOMAINS_LABEL = "SELECTED DOMAINS";
export const WHITELIST_APPLICATION_LABEL = "Application Name *";
export const WHITELIST_APPLICATION_PLACEHOLDER = "Select Application Name";
export const WHITELIST_APPLICATION_OPTIONS = [
  {
    label: "S&OP - Sales And Operations Planning",
    value: "SALES_AND_OPERATIONAL_PLANNING",
    businessJustification: "Enable bottler users to submit forecast data for demand review process for S&OP.",
  },
];
export const WHITELIST_JUSTIFICATION_LABEL       = "Business Justification *";
export const WHITELIST_JUSTIFICATION_PLACEHOLDER = "Provide business reason for whitelisting...";
export const BTN_SUBMIT             = "Submit";

// ── Remove Whitelist ───────────────────────────────────────────────────────
export const BLACKLIST_TITLE        = "Remove Whitelist";
export const BLACKLIST_DESCRIPTION  = "The selected domains will be removed from the whitelist. This action will update their status to Inactive.";
export const BLACKLIST_WARNING      = "Removing a domain from whitelist will revoke supplier collaboration access. Please ensure this is intentional before proceeding.";
export const BLACKLIST_DOMAINS_LABEL = "DOMAINS TO BE REMOVED FROM WHITELIST";
export const BLACKLIST_REQUESTED_FOR = "Requested For";
export const BLACKLIST_REASON_LABEL  = "Reason For Removal *";
export const BLACKLIST_REASON_PLACEHOLDER = "Provide the reason for removing these domains...";
export const BLACKLIST_DEFAULT_REASON = "Disable bottler users to submit forecast data for demand review process for S&OP.";
export const BTN_CONFIRM            = "Confirm";
